"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Line = function (_a) {
    var backgroundColor = _a.backgroundColor;
    return (0, jsx_runtime_1.jsx)("div", { style: { height: 1, backgroundColor: backgroundColor || '#FF4F6B', width: '100%' } });
};
exports.default = Line;
